export default __webpack_public_path__ + "static/media/bg_bggenerator_com.557337c9.png";